import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import {
  PoModule,
  PoFieldModule,
  PoPageModule,
  PoModalModule,
} from "@po-ui/ng-components";
import { Routes, RouterModule } from "@angular/router";
import { PoModalPasswordRecoveryModule, PoTemplatesModule } from "@po-ui/ng-templates";

//Serviços
import { AuthGuard } from "./guards/auth.guard";
import { ProspectListService } from "./prospects/prospect-list/prospect-list.service";

//Componentes do APP
import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login/login.component";
import { ProspectListComponent } from "./prospects/prospect-list/prospect-list.component";
import { ProspectViewComponent } from "./prospects/prospect-view/prospect-view.component";
import { ProspectFormComponent } from "./prospects/prospect-form/prospect-form.component";
import { ClientesListComponent } from "./clientes/clientes-list/clientes-list.component";
import { ClientesViewComponent } from "./clientes/clientes-view/clientes-view.component";
import { EstoqueListComponent } from "./estoque/estoque-list/estoque-list.component";
import { OrcamentoListComponent } from "./orcamento/orcamento-list/orcamento-list.component";
import { OrcamentoFormComponent } from "./orcamento/orcamento-form/orcamento-form.component";
import { OrcamentoViewComponent } from "./orcamento/orcamento-view/orcamento-view.component";
import { OrcamentoPrintComponent } from "./orcamento/orcamento-print/orcamento-print.component";

import { AreaTecnicaClienteComponent } from "./areateccliente/areateccliente.component";

import { AdmOrcamentoListComponent } from "./orcamento_adm/adm_orcamento-list/adm_orcamento-list.component";
/*
import { AdmOrcamentoViewComponent } from "./orcamento_adm/adm_orcamento-view/adm_orcamento-view.component";
import { AdmOrcamentoPrintComponent } from "./orcamento_adm/adm_orcamento-print/adm_orcamento-print.component";
*/
import { FinanceiroComponent } from "./financeiro/financeiro.component";
import { PasswordComponent } from "./password/password.component";
import { SsoComponent } from "./sso/sso.component";

import {AreaTecnicaAdminComponent} from "./areatecadmin/areatecadmin.component";

import { YouTubePlayerModule } from "@angular/youtube-player";
import { ProspectViewModule } from './prospects/prospect-view/prospect-view.module';
import { ProspectListModule } from './prospects/prospect-list/prospect-list.module';
import { ProspectFormModule } from './prospects/prospect-form/prospect-form.module';
import { clientesListModule } from './clientes/clientes-list/clientes-list.module';
import { clientesViewModule } from './clientes/clientes-view/clientes-view.module';
import { LoginModule } from './login/login.module';
import { EstoqueListModule } from './estoque/estoque-list/estoque-list.module';
import { QRCodeComponent } from 'angularx-qrcode';
import { CommonModule } from '@angular/common';


//[*Rotas]
const APP_ROUTES: Routes = [
  { path: "login", component: LoginComponent },
  { path: "sso", component: SsoComponent },
  { path: "", component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: "prospect-list",
    component: ProspectListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "prospect-view/:id",
    component: ProspectViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "prospect-form",
    component: ProspectFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "clientes-list",
    component: ClientesListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "clientes-view/:id",
    component: ClientesViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "estoque-list",
    component: EstoqueListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "orcamento",
    component: OrcamentoListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "orcamento-form",
    component: OrcamentoFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "orcamento-view/:id",
    component: OrcamentoViewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "orcamento-print/:id",
    component: OrcamentoPrintComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "orcamentocliente/:id/:cgc",
    component: OrcamentoPrintComponent,
  },
  {
    path: "adm_orcamento",
    component: AdmOrcamentoListComponent,
  },
  {
    path: "financeiro",
    component: FinanceiroComponent,
  },
  {
    path: "passwd",
    component: PasswordComponent,
  },
  {
    path: "areaTecnicacliente",
    component: AreaTecnicaClienteComponent,
  },
  {
    path: "areaTecnicaAdmin",
    component: AreaTecnicaAdminComponent,
  },
  
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    OrcamentoListComponent,
    OrcamentoFormComponent,
    OrcamentoViewComponent,
    OrcamentoPrintComponent,
    AdmOrcamentoListComponent,
    FinanceiroComponent,
    PasswordComponent,
    AreaTecnicaClienteComponent,
    AreaTecnicaAdminComponent,
    SsoComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    PoModule,
    RouterModule.forRoot(APP_ROUTES), // [*Router],
    PoTemplatesModule,
    PoFieldModule,
    PoModalModule,
    PoPageModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    QRCodeComponent,
    LoginModule,
    clientesListModule,
    clientesViewModule,
    EstoqueListModule,
    YouTubePlayerModule, 
    PoModalModule, 
    PoModalPasswordRecoveryModule,
  ],
  providers: [AuthGuard, ProspectListService, 
    provideHttpClient(withInterceptorsFromDi()),],
  bootstrap: [AppComponent],
})
export class AppModule {}
